import { createContext } from 'react';
const PracticeContext = createContext();
export default PracticeContext;